import { useMemo } from "react";

export function Embers({ count = 26 }) {
  const dots = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        left: `${Math.random() * 100}%`,
        size: 2 + Math.random() * 3,
        dur: 9 + Math.random() * 12,
        delay: -Math.random() * 20,
        drift: `${(Math.random() - 0.5) * 120}px`,
        key: i,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {dots.map((d) => (
        <span
          key={d.key}
          className="ember"
          style={{ left: d.left, width: d.size, height: d.size, animationDuration: `${d.dur}s`, animationDelay: `${d.delay}s`, "--drift": d.drift }}
        />
      ))}
    </div>
  );
}
